<div class="dialog-title">
    <div  style="vertical-align:middle; display: flex;
    align-items:center;">
    <mat-icon style="font-size: 48px; width:48px; height:48px; margin-right: 12px;">date_range</mat-icon>
    {{this.getTitle() | translate}}
  </div>
</div>

<mat-divider></mat-divider>
<div mat-dialog-content>
  <p>{{'Startseite.Abwesenheitinfo' | translate}}</p>
</div>

<mat-form-field appearance="fill" class="form-field" floatLabel="always">
  <mat-label>{{'Von' | translate}}</mat-label>

  <input #vonInput matInput style="margin: 0px"
    [value]="data.von | date:'dd.MM.yyyy'"
    (change)="data.von=this.oroservice.ChangeDate(vonInput.value);"
    autocomplete='off'>
    <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]='data.von'>

    <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
    <mat-datepicker #pickerVon></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill" class="form-field" floatLabel="always">
    <mat-label>{{'Bis' | translate}}</mat-label>

    <input #bisInput matInput style="margin: 0px"
      [value]="data.bis | date:'dd.MM.yyyy'"
      (change)="data.bis=this.oroservice.ChangeDate(bisInput.value);"
      autocomplete='off'>
      <input type="hidden" [matDatepicker]="pickerBis" [(ngModel)]='data.bis'>

      <mat-datepicker-toggle matSuffix [for]="pickerBis" tabindex="-1"></mat-datepicker-toggle>
      <mat-datepicker #pickerBis></mat-datepicker>
    </mat-form-field>

    @if (hasError()) {
      <div class="absence-error">
        {{'Startseite.Abwesenheitbisvorvon' | translate}}
      </div>
    }

    <div mat-dialog-actions>
      <button mat-flat-button color="primary" class="button-dialog" [disabled]="!canSubmit()"
      (click)="submit()">{{'Startseite.Anlegen' | translate}}</button>
      <button mat-flat-button color="primary" class="button-dialog"
      [mat-dialog-close]=false>{{'abbrechen' | translate}}</button>
    </div>
